import { 
  OFFER_TELCEL_POSPAGO, 
  OFFER_TELCEL_RECARGA,
  OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE,
  OFFER_TELCEL_PAQUETE_INTERNET_AMIGO,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO,
  OPEN_NEW_MICROAPP,
  REDIRECT,
  OFFER_TELCEL_AMIGO_PAGUITOS,
  ACTION_COOKIE_SAVE,
  OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN
} from "../../constants";
import { datadogRum } from '@datadog/browser-rum';
import defaultMessagesMiniAppTelcel from "../../services/messaging/miTelcel.json"

export function validateUserAgent () {
  if (/Android/i.test(navigator.userAgent)) {
    return "android"
  }
}

export function getMessage (messages, code, flux){
  const message = messages.find(message => message.code ===  code);
  if (message) {
    return message;
  } else {
    if (flux && flux === "MiniAppTelcel") {
      return defaultMessagesMiniAppTelcel.find(message => message.code === code)
    }
  } 
}

export function getTypeOfferValue(typeOffer){
  switch (typeOffer) {
    case "OFFER_TELCEL_POSPAGO":
      return OFFER_TELCEL_POSPAGO
    case "OFFER_TELCEL_RECARGA":
      return OFFER_TELCEL_RECARGA
    case "OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE":
      return OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE
    case "OFFER_TELCEL_PAQUETE_INTERNET_AMIGO":
      return OFFER_TELCEL_PAQUETE_INTERNET_AMIGO
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO
    case "OFFER_TELCEL_AMIGO_PAGUITOS":
      return OFFER_TELCEL_AMIGO_PAGUITOS
    case "OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL":
      return OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL
      case "OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN":
        return OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN
    default:
      break;
  }
}

export function getTypeEventValue(typeEvent){
  switch (typeEvent) {
    case "OPEN_NEW_MICROAPP":
      return OPEN_NEW_MICROAPP
    case "REDIRECT":
      return REDIRECT
    default:
      break;
  }
}

export const datadogMonitor = (tagServiceId, sessionReplaySampleRate) => {
  datadogRum.init({
    applicationId: `${process.env.REACT_APP_DATADOG_APPLICATION_ID}`,
    clientToken: `${process.env.REACT_APP_DATADOG_CLIENT_TOKEN}`,
    site: `${process.env.REACT_APP_DATADOG_SITE}`,
    env: `${process.env.REACT_APP_DATADOG_ENV}`,
    service: `${tagServiceId}`,
    // version: '1.0.0', 
    sessionSampleRate: 100,
    sessionReplaySampleRate: parseInt(sessionReplaySampleRate),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

const validatePostMessageTelcelCookieStructure = (cookieInformation) => {
  if(!cookieInformation.includes("setImmediate")){
    const cookieValue = JSON.parse(cookieInformation)
    if(
      cookieValue.hasOwnProperty('action') &&
      cookieValue.hasOwnProperty("cname") &&
      cookieValue.hasOwnProperty("cvalue")
      ){
      return cookieValue
    } else{
      return false
    }
  } else{
    return false
  }
}

const validateCookieExist = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return true
      }
    }
    return false;
}

export const saveCookie = (cookieInformation) => {
  const cookieValueJson = validatePostMessageTelcelCookieStructure(cookieInformation);
  if(cookieValueJson){
    const {action, cname, cvalue, exdays} = cookieValueJson
    if(action == ACTION_COOKIE_SAVE) {
      if(!validateCookieExist(cname)){
        const date = new Date();
        date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        const cookieValueToSave = cname + "=" + cvalue + ";" + expires + ";";
        document.cookie = cookieValueToSave;
        const frameEmb = document.getElementById('frameTelcel');
          /*setTimeout(() => {
            frameEmb.contentWindow.postMessage(
              {
                cookieName : cname,
                coockieValue: cookieValueToSave
              }, 
              '*'
              );
          }, 3000);*/
      }
    }
  }
}

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const setDomiciliationMsgInitialDate = (text, date) => {
  const setInitialDate = text.replaceAll("{fecha}", date);
  return setInitialDate.replaceAll("{periodicidad}", "mes");
};

export const formatEpochDate = (epochDate) => {
  const date = new Date(Number(epochDate));
  const yyyy = date.getFullYear();
  const numberString = (String(date.getMonth() + 1))
  const mm = (numberString.length) ? "0" + (numberString) : numberString
  const day = date.getDate();
  const dd = (day < 10) ? "0" + day : day
  return dd + "/" + mm + "/" + yyyy
};

export const getSumDaysDate = (days) => {
  const today = new Date();
  const tzoffset = (new Date()).getTimezoneOffset() * 60000;
  return new Date(today.setDate(today.getDate() + days) - tzoffset)
    .toISOString()
    .split("T")[0];
  
}

export const getRequirementsAdvancementClaroPay = (user) => {
  let isUserApprove = false;
  if(user.advancePayment){
    if(user.advancePayment.approved && Number(user.advancePayment.score) > 0){
      isUserApprove = true;
    }
  }
  return isUserApprove;
}

export const existConfigFavorites = (dataConfigInputs, amount) => {
  const dataConf = dataConfigInputs.find(config => config.id === 'buttonBox');
  if (dataConf && dataConf.cp) {
    return dataConf.cp.find(input => input.id === 'favoritos') ? true : false
  }
}

export const formatCurrency = new Intl.NumberFormat("en-Latn-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingIncrement: 5,
});


export function getDomiciliationExpirationDate(expirationDate) {
  
  const dateFromForm = new Date(expirationDate)

  const monthFromForm = dateFromForm.getMonth(); //(January gives 0)
  
  const dayFromform = dateFromForm.getDate()

  const yearFromForm = dateFromForm.getFullYear();
  
  const currentDate = new Date();

  const currentday = currentDate.getDate();

  const currentMoth = currentDate.getMonth();

  if(monthFromForm === 11){

    const nextMonthOfYearTotalDays = new Date(yearFromForm+1, 1, 0).getDate();
    
    const nextMonthTotalDays = new Date(yearFromForm, monthFromForm+2, 0).getDate();

    if(dayFromform <= currentday){
      if(dayFromform <=  nextMonthOfYearTotalDays){
        return `${yearFromForm+1}/01/${dayFromform}`
      }
      if( dayFromform > nextMonthTotalDays){
        return `${yearFromForm+1}/01/${nextMonthTotalDays}`
      }
    }
    return expirationDate

  } else {

    const nextMonthTotalDays = new Date(yearFromForm, monthFromForm+2, 0).getDate();
    
    if(monthFromForm < currentMoth ){
      console.log(monthFromForm, "mes seleccionado es menor a mes actual");
      if(dayFromform <=  nextMonthTotalDays){
        return `${yearFromForm}/${monthFromForm+2}/${dayFromform}`
      }
      if( dayFromform > nextMonthTotalDays){
        return `${yearFromForm}/${monthFromForm+2}/${nextMonthTotalDays}`
      }
      return expirationDate
    } else if(monthFromForm === currentMoth ) {
      if(dayFromform <= currentday && dayFromform <=  nextMonthTotalDays){
        return `${yearFromForm}/${monthFromForm+2}/${dayFromform}`
      }
      if( dayFromform <= currentday && dayFromform > nextMonthTotalDays){
        return `${yearFromForm}/${monthFromForm+2}/${nextMonthTotalDays}`
      }
      return expirationDate
    } else {
      return expirationDate
    }
  }
}

export function buttonDomiciliationConfigExist(dataConfigElements){
  const buttonBoxElements = dataConfigElements.find((elem) => elem.id == "buttonBox" );
  if(buttonBoxElements){
    const  result = buttonBoxElements.cp.find((button) => button.id == "domiciliar" )
    return result ? true : false
  }else{
    return false
  }
}

export function buttonMorePackagesConfigExist(dataConfigElements){
  const buttonBoxElements = dataConfigElements.find((elem) => elem.id == "buttonBox" );
  if(buttonBoxElements){
    const  result = buttonBoxElements.cp.find((button) => button.id == "mas_paquetes_pospago" )
    return result ? true : false
  }else{
    return false
  }
}

export function getPaymentFlowForTaggeo(isAnonimous, msisdn, paymentMethods) {
  if (isAnonimous && msisdn) {
    return "Solo MSISDN";
  }

  if (!isAnonimous && paymentMethods) {
    if (!paymentMethods.hasN2 && (!paymentMethods.cardList || Object.keys(paymentMethods.cardList.length === 0))) {
      return "Usuario sin método"
    } else {
      return "Usuario con método"
    }
  }
}